const user = JSON.parse(localStorage.getItem('userData'))
const menu = [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    tag: '2',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'eCommerce',
        route: 'dashboard-ecommerce',
      },
      {
        title: 'Analytics',
        route: 'dashboard-analytics',
      },
    ],
    roles: [1, 2, 3, 4, 5, 6, 7], // todos
  },
]

const filteredMenu = menu.filter(item => item.roles.includes(parseInt(user.role_id, 10)))

export default filteredMenu
